/**
 * Lazysizes helpers for Kirby media snippets.
 */

export { bindFeaturedCoverFades, initFeaturedCoverMedia } from "./featured-cover-media";

export function configureLazySizes() {
  if (!window.lazySizes) {
    return;
  }

  window.lazySizes.cfg = window.lazySizes.cfg || {};
  window.lazySizes.cfg.loadMode = 1;
  window.lazySizes.cfg.expand = 280;
}

export function initLazyMedia(root = document) {
  const scope = root?.querySelector ? root : document;
  const container = scope === document ? document.getElementById("main") : scope;

  if (!container || !window.lazySizes?.loader) {
    return;
  }

  window.lazySizes.loader.checkElems(container);
}
